function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#2a343f}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "lh3dfX",
  transform: "translate(-177.246 -290.605)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3210",
  "data-name": "Group 3210",
  transform: "translate(190.861 291.029)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4145",
  d: "M254.177 361.608h-53.125v-40.677c-1.746-.551-3.412-.2-5.046-.268-1.587-.063-3.177-.014-4.736-.014-.436-1.66-.564-14.83-.184-18.659h9.814v-10.723a10.627 10.627 0 0 1 1.439-.215q18.924-.014 37.848-.023a3.32 3.32 0 0 1 2.6 1.056q5.266 5.373 10.635 10.645a2.816 2.816 0 0 1 .919 2.2q-.038 27.93-.027 55.86a5.862 5.862 0 0 1-.137.818zm-51.8-40.959v1.844q.03 18.69.065 37.38c0 .061.074.124.12.181s.1.111.157.166c6.77.362 48.187.2 50.09-.21v-55.275c-2.055 0-4.012.04-5.967-.011-2.016-.052-4.055.236-6.252-.255v-11.9c-.489-.052-.779-.11-1.068-.11q-18.349.02-36.7.054c-.063 0-.131.063-.187.108s-.1.11-.265.284c0 1.387-.018 2.9.005 4.417a37.033 37.033 0 0 0 .085 4.379c.264.119.33.175.4.175q16.411.031 32.821.056a8.9 8.9 0 0 1 .908.063c.062.006.12.08.176.128s.108.106.134.131v18.4H202.38zm-9.869-17.263c-.4 3.728-.276 14.259.164 15.78 5.98.331 40.918.179 42.768-.186.375-3.448.246-14.066-.2-15.594zm49.609-.06h4.668c1.533-.006 3.069.025 5.08-.034-3.224-3.189-6.073-6.011-8.928-8.827-.21-.207-.46-.374-.82-.664z",
  className: "cls-2",
  "data-name": "Path 4145",
  transform: "translate(-190.861 -291.029)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4149",
  d: "M255.236 372.526a24.494 24.494 0 0 1-.724 4.563c-.863 2.548.3 4.227 1.935 5.831.432.423.942.766 1.392 1.173a4.31 4.31 0 0 0 3.516 1.211 25.333 25.333 0 0 1 4.323-.032 11.627 11.627 0 0 1 3.085.652 2.633 2.633 0 0 1 1.786 3.038 2.68 2.68 0 0 1-3.175 1.514 17.437 17.437 0 0 1-6.476-2.656 4.184 4.184 0 0 0-3.218-.668 35.538 35.538 0 0 0-7.426 2.023 4.015 4.015 0 0 0-1.7 1.371c-1.277 1.692-2.582 3.374-4.01 4.937a8.9 8.9 0 0 1-2.572 1.822 3.309 3.309 0 0 1-1.974.218 1.828 1.828 0 0 1-1.361-2.6 5.481 5.481 0 0 1 1.754-2.267 68.489 68.489 0 0 1 6.522-3.671 4.262 4.262 0 0 0 2.07-1.659 34.85 34.85 0 0 0 3.046-6.326 5.125 5.125 0 0 0 .017-3.307A17.948 17.948 0 0 1 251 371a8.093 8.093 0 0 1 .407-1.978 1.714 1.714 0 0 1 1.973-1.178 1.773 1.773 0 0 1 1.673 1.582c.147.899.116 1.819.183 3.1zm-9.224 18.664c-1.079.509-2.2.944-3.222 1.552a15.473 15.473 0 0 0-2.3 1.821c-.4.357-.752.912-.253 1.363a1.278 1.278 0 0 0 1.209.055c1.885-1.244 3.669-2.614 4.532-4.827l.218-.272zm4.717-3.82l6.17-1.658-3.6-3.6zm18.487 1.166c-1.236-1.831-3.217-2.3-6.8-1.626a12.607 12.607 0 0 0 5.682 2.2c.336.048.736-.366 1.118-.573zm-16.175-12.755c.986-3.506.986-5.115.022-6.58-1.436 2.254-.263 4.432-.022 6.58z",
  className: "cls-2",
  "data-name": "Path 4149",
  transform: "translate(-216.747 -332.81)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4150",
  d: "M235.258 324.071c1.111 0 2.092-.04 3.07.008a3.959 3.959 0 0 1 3.972 3.854 13.718 13.718 0 0 1 0 1.816 3.932 3.932 0 0 1-3.766 3.816c-1.048.071-2.106.012-3.133.012a36.272 36.272 0 0 1-.143-9.506zm1.65 1.7a47.642 47.642 0 0 0 .154 6.121c2.091.347 3.085-.253 3.344-2a7.456 7.456 0 0 0 .006-2.035c-.23-1.772-1.157-2.357-3.504-2.087z",
  className: "cls-2",
  "data-name": "Path 4150",
  transform: "translate(-214.882 -308.994)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4151",
  d: "M216.1 324.074c1.629 0 2.914-.082 4.186.02a3.17 3.17 0 0 1 3.085 2.771 2.709 2.709 0 0 1-2.539 3.121c-.816.094-1.644.09-2.7.143l-.262 3.25-1.692.223c-.155-3.18-.032-6.227-.078-9.528zm1.947 4.532c.819 0 1.418.005 2.018 0a1.3 1.3 0 0 0 1.423-1.166 1.569 1.569 0 0 0-1.036-1.8 2.412 2.412 0 0 0-2.4.278z",
  className: "cls-2",
  "data-name": "Path 4151",
  transform: "translate(-204.587 -308.987)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4152",
  d: "M259.7 328.141c.3.909.254 1.4-.5 1.432-.971.037-1.946.009-3.155.009l-.252 3.823-1.362.21c-.515-.566-.606-5.827-.215-9.486 1.827 0 3.691-.034 5.552.017.719.02.817.521.462 1.286l-3.9.174c-.661.775-.429 1.568-.354 2.534z",
  className: "cls-2",
  "data-name": "Path 4152",
  transform: "translate(-225.191 -309.028)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4157",
  d: "M254.987 418.671l.181-.31-.218.272z",
  className: "cls-2",
  "data-name": "Path 4157",
  transform: "translate(-225.722 -360.29)"
})));

var SvgPdfReportIcon = function SvgPdfReportIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3091",
    width: 93.116,
    height: 77.03,
    "data-name": "Group 3091",
    viewBox: "0 0 93.116 77.03",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Group_3090",
    "data-name": "Group 3090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Excercise",
    "data-name": "Background Excercise"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    fill: "#33b0ce",
    d: "M10.463 15.558c7.364-4.084 16.167-4.784 24.542-6.3 5.471-1 10.372-3.176 15.467-5.108C63.528-.726 79.085-3.293 87.979 7.986c7.377 9.4 7.2 26.565-3.086 36.3A23.337 23.337 0 0 1 72.6 50.161c-2.684.48-5.912.311-8.31 2.165s-3.591 5.653-4.771 8.427c-1.75 4.149-3.617 8.5-6.755 11.876-7.234 7.779-14.443 4.3-20.134-3.1-.752-.959-15.921-19.81-21.3-23.337C6.56 43 1.738 39.076.363 33.708c-1.543-6.106 2-12.5 7.157-16.271a29.015 29.015 0 0 1 2.943-1.88z",
    "data-name": "Path 926",
    transform: "translate(.001)",
    style: {
      isolation: "isolate"
    },
    opacity: 0.21
  }))), _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPdfReportIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pdf-report-icon.fccd3c9a.svg";
export { ForwardRef as ReactComponent };